import z from 'zod';
import { kebabString } from '../../custom-events/base-fields';

export default z.object({
  category: kebabString,
  subCategory: kebabString.optional(),
  type: kebabString,
  id: z.string().optional(),
  brand: z.object({ name: z.string() }).optional(),
  pageName: z.string().optional(),
});
